import { render, staticRenderFns } from "./EventInfoCoreDetails.vue?vue&type=template&id=21ba6933&scoped=true&"
import script from "./EventInfoCoreDetails.vue?vue&type=script&lang=ts&"
export * from "./EventInfoCoreDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EventInfoCoreDetails.vue?vue&type=style&index=0&id=21ba6933&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba6933",
  null
  
)

export default component.exports